<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}" class="pageHeader">{{$store.state.themeTitle}}大纲</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择审批状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="大纲名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入大纲名称"></el-input>
        </el-form-item>
        <el-form-item label="所属实训">
          <el-select v-model="formInline.training_id" clearable filterable placeholder="请选择所属实训">
            <el-option v-for="item in wdsxsqs" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增{{$store.state.themeTitle}}大纲</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed prop="name" label="大纲名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="training_name" label="所属实训" width="180">
        </custom-table-column>
        <custom-table-column prop="md" label="目的与要求" min-width="180">
        </custom-table-column>
        <custom-table-column prop="nr" label="内容与目标" min-width="180">
        </custom-table-column>
        <custom-table-column prop="sxjhnr" label="实训计划" min-width="280">
          <template slot-scope="scope">
            <template v-if="isJsonString(scope.row.sxjhnr)">
              <p v-for="(item,index) in JSON.parse(scope.row.sxjhnr)" :key="index">内容：{{item.sxnr?item.sxnr:'无'}}; 学时：{{item.xs?item.xs:'无'}}; 备注：{{item.bz?item.bz:'无'}};</p>
            </template>
            <span v-else>{{scope.row.sxjhnr}}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="khbz" label="考核标准" min-width="180">
        </custom-table-column>
        <custom-table-column prop="qtsx" label="其他事项" min-width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button @click="handleEdit(scope.row,['school_Id','created_at','deleted_at'])" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <!-- <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery"></OrganDialog> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="大纲名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入大纲名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所属实训" prop="training_id">
          <el-select v-model="ruleForm.training_id" filterable style="width:216px;" placeholder="请选择实训" @change="handleClassChange">
            <el-option v-for="item in wdsxsqs" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目的与要求" prop="md">
          <el-input type="textarea" v-model="ruleForm.md" placeholder="请输入目的与要求" :rows="3" style="width:542px;"></el-input>
        </el-form-item>
        <el-form-item label="内容与目标" prop="nr">
          <el-input type="textarea" v-model="ruleForm.nr" placeholder="请输入内容与目标" :rows="3" style="width:542px;"></el-input>
        </el-form-item>
        <el-form-item label="实训计划" prop="sxjhnr">
          <div class="dalog_win" style="width:542px;">
            <!-- <p style="text-indent:48px;font-size:16px;margin-bottom:32px;"></p> -->
            <div v-for="(item,index) in plist" :key="index" class="dalog_win_item">
              <el-form-item label="实训内容" prop="sxnr">
                <el-input v-model="item.sxnr" placeholder="请输入实训内容" style="width:382px;"></el-input>
              </el-form-item>
              <el-form-item label="学  时" prop="xs">
                <el-input-number v-model="item.xs" :min="0" placeholder="请输入学时" style="width:382px;"></el-input-number>
              </el-form-item>
              <el-form-item label="备注" prop="bz">
                <el-input type="textarea" v-model="item.bz" placeholder="请输入内备注" :rows="3" style="width:382px;"></el-input>
              </el-form-item>
              <div style="margin-top:12px;text-align:center;">
                <el-button type="danger" @click="handleItemDelete(item,index)" size="mini">删除</el-button>
              </div>
            </div>
            <div style="margin-top:12px;text-align:center;">
              <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="考核标准" prop="khbz">
          <el-input type="textarea" v-model="ruleForm.khbz" placeholder="请输入考核标准" :rows="3" style="width:542px;"></el-input>
        </el-form-item>
        <el-form-item label="其他事项" prop="qtsx">
          <el-input type="textarea" v-model="ruleForm.qtsx" placeholder="请输入其他事项" :rows="3" style="width:542px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="院系专业" prop="major">
          <el-input v-model="selectName" placeholder="请选择院系+专业" style="width:552px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
        </el-form-item> -->

        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
// import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
// import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinImport],
  data() {
    return {
      formInline: {
        name: '',
        training_id: '',
      },
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      ruleForm: {
        name: '',
        training_id: '',
        md: '',
        nr: '',
        sxjhnr: '',
        khbz: '',
        qtsx: '',
      },
      plist: [],
      ruleForm1: {
        sxnr: '',
        xs: 0,
        bz: '',
      },
      numberDialogVisible: false,
      classRooms: [],
      rules: {
        name: [{ required: true, message: '请输入大纲名称', trigger: 'blur' }],
        training_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        md: [{ required: true, message: '请输入目的与要求', trigger: 'blur' }],
        nr: [{ required: true, message: '请输入内容与目标', trigger: 'blur' }],
        khbz: [{ required: true, message: '请输入考核标准', trigger: 'blur' }],
        sxjhnr: [{ required: true, message: '请输入实训内容' }],
      },
      numberDialogVisible1: false,
      ruleForm2: {
        goods_id: '',
        use_at: '',
        usage: '',
      },
      rules2: {
        use_at: [{ required: true, message: '请选择废弃时间', trigger: 'change' }],
        usage: [{ required: true, message: '请输入用途', trigger: 'blur' }],
      },
      action: '',
      downloadUrl: 'template/实训导入模版.xlsx',
      downloadName: '实训导入模版.xlsx',
      btnTitle: '导入实训数据',
      exportUrl: '',
      wdsxsqs: [],
    };
  },
  created() {
    // this.action = `${this.baseUrlt}api/danger_goods/import`;
    // this.exportUrl = `${this.baseUrlt}api/consume/queryExport`;
    // this.$store.dispatch('getTarinMent');
    // this.$store.dispatch('getParams');
    this.getWdsxsq();
  },
  watch: {
    plist: {
      handler: function (val) {
        this.ruleForm.sxjhnr = JSON.stringify(val);
      },
      deep: true,
    },
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return (this.ruleForm.quantity * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() {},
  methods: {
    handleDelet(id) {
      this.confirmBox('warning', `此操作将删除该大纲，是否继续`, { id }, this.deleteMethod);
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch {
        return false;
      }
    },
    handleItemDelete(item, index) {
      this.plist.splice(index, 1);
    },
    handleItemAdd() {
      this.plist.push({ sxnr: '', xs: 0, bz: '' });
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getWdsxsq() {
      let params = {
        page: 1,
        size: 9999,
        status: 'pass',
      };
      let res = await this.$api.instance.interfaceServer('api/sxgf/practical_training/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.wdsxsqs = res.data.data;
      }
    },
    async deleteMethod(params) {
      // let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/sxgf/practical_training/outline/delete/${params.id}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/sxgf/practical_training/outline/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/sxgf/practical_training/outline/edit/${this.ruleForm.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/sxgf/practical_training/outline/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.structure_1 && row.major) {
        this.selectName = `${row.structure_1}-${row.major}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.el-form-item .el-form-item {
  margin-bottom: 22px;
}
</style>
